/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled, use } from 'fierry/react';

import Text from 'solis/react/primitive/text';

import Galaxy from 'solis/application/galaxy';

import Countdown from 'solis/claude/element/countdown';


const getBoardDestroyDate = (galaxy, sector) =>
{
  return galaxy.getBoard(sector.getColony().cass.board).cass.destroyDate;
};


const getBoardCurrencyGain = (galaxy, sector) =>
{
  const board = galaxy.getBoard(sector.getColony().cass.board);

  return board.getColony(sector.cass.colony).getSector(sector.cass.id).cass.currency - sector.cass.currency;
};


const Gain = styled(Text)`
  font-variant-numeric: tabular-nums;
`;


const getGainColor = (gain) =>
{
  return gain == 0 ? 'gray' : null;
};


const Component = ({ gain, date }) =>
(
  <Flex align = 'center' gap = '1'>
    <Gain size = '1' color = {getGainColor(gain)}>{'+' + gain}</Gain>
    <Text.Note>{'in '}<Countdown date = {date} compact /></Text.Note>
  </Flex>
);


export default ({ sector }) =>
{
  const galaxy = use(Galaxy);

  if (!sector.getColony().cass.board)
  {
    return null;
  }

  return <Component gain = {getBoardCurrencyGain(galaxy, sector)} date = {getBoardDestroyDate(galaxy, sector)} />;
};
